import type { FC } from "react";

type TooltipProps = Record<string, never>;

export const TooltipIcon: FC<TooltipProps> = (_props) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.6667V7.33333H7.66667M8 10.6667H7.66667M8 10.6667H8.33333M8 5.66667V5.33333M14 8C14 11.3137 11.3137 14 8 14C4.68629 14 2 11.3137 2 8C2 4.68629 4.68629 2 8 2C11.3137 2 14 4.68629 14 8Z"
        stroke="#383838"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
